import { render, staticRenderFns } from "./SetPlanModal.vue?vue&type=template&id=1ba42da3&scoped=true&"
import script from "./SetPlanModal.vue?vue&type=script&lang=js&"
export * from "./SetPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./SetPlanModal.vue?vue&type=style&index=0&id=1ba42da3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba42da3",
  null
  
)

export default component.exports